import React from 'react';
import { DefaultButton, IButtonStyles } from '@fluentui/react';

const styles : IButtonStyles = {
    root: {
        backgroundColor: '#ffffff',
        color: '#333333',
        borderColor: '#666666',
        padding: 0,
    },
    rootHovered: {
        backgroundColor: 'var(--color-primario)',
        color: '#ffffff',
        borderColor: 'var(--color-primario)',
    },
    label: {
        fontWeight: 500,
    },
};

interface ICloseModalButtonComponentProps {
    onClick: () => void;
};

const CloseModalButtonComponent = (props: ICloseModalButtonComponentProps) => {
    return (
        <DefaultButton 
            styles={styles}
            iconProps={{
                iconName: 'ChromeClose',
                className: 'mx-0',
            }}
            onClick={props.onClick} />
    );
};

export default CloseModalButtonComponent;
